<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';

@Component
export default class AboutContentBlock extends Vue {
  @Prop({ required: true }) private icon!: string;
  @Prop({ required: true }) private title!: string;
  @Prop({ default: 'teal' }) private variant!: 'teal' | 'terracotta' | 'stone' | 'elevated' | 'surface' | 'beige';

  private get glassClass() {
    return `ln-glass-${this.variant}`;
  }
}
</script>

<template>
  <section :class="['about-block', glassClass]">
    <div class="block-header">
      <div class="icon-wrapper">
        <span :class="['mdi', icon]"></span>
      </div>
      <h2>{{ title }}</h2>
    </div>
    <div class="block-content">
      <slot></slot>
    </div>
  </section>
</template>

<style scoped>
.about-block {
  margin-bottom: 3rem;
  padding: 3rem;
  border-radius: var(--ln-radius-lg);
  transition: all var(--ln-transition-normal) var(--ln-ease-smooth);
  position: relative;
  overflow: hidden;
}

.about-block:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 60px var(--ln-glass-shadow-elevated);
}

.block-header {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.icon-wrapper {
  width: 60px;
  height: 60px;
  background: var(--ln-glass-surface);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--ln-glass-border-strong);
}

.icon-wrapper span.mdi {
  font-size: 2rem;
  color: var(--ln-teal-deep);
}

.ln-glass-terracotta .icon-wrapper span.mdi { color: var(--ln-terracotta-subtle); }
.ln-glass-stone .icon-wrapper span.mdi { color: var(--ln-stone-grey); }
.ln-glass-beige .icon-wrapper span.mdi { color: var(--ln-beige-sable); }

.block-header h2 {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
  background: linear-gradient(135deg, var(--ln-text-primary) 30%, var(--ln-teal-deep));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.ln-glass-terracotta .block-header h2 { background-image: linear-gradient(135deg, var(--ln-text-primary) 30%, var(--ln-terracotta-subtle)); }
.ln-glass-stone .block-header h2 { background-image: linear-gradient(135deg, var(--ln-text-primary) 30%, var(--ln-stone-grey)); }

.block-content {
  position: relative;
  z-index: 2;
  font-size: 1.1rem;
  color: var(--ln-text-secondary);
}

@media (max-width: 768px) {
  .about-block {
    padding: 2rem 1.5rem;
  }
  
  .block-header {
    gap: 1rem;
    margin-bottom: 1.5rem;
  }
  
  .icon-wrapper {
    width: 48px;
    height: 48px;
  }
  
  .icon-wrapper span.mdi {
    font-size: 1.5rem;
  }
  
  .block-header h2 {
    font-size: 1.5rem;
  }
}
</style>
